<template>
  <div>
    <div class="row" v-if="editing">
            <div class="col-4">
              <label for="">{{ $t('insights.ui.timespan.label') }}</label>
              <select name="" class=form-control v-model="config.weekDifference" id="">
                <option value="-1">{{ $t('insights.ui.timespan.lastWeek') }}</option>
                <option value="0">{{ $t('insights.ui.timespan.currentWeek') }}</option>
              </select>
            </div>
      <div class="col-3">
        <label for="title-planning">{{ $t('ui.title') }}</label>
        <input type="text" id="title-planning" class="form-control" v-model="config.title">
      </div>

    </div>

       <div class="row" v-if="!editing">
        <div class="col-4">
          <label for="">{{ $t('insights.ui.timespan.label') }}</label>
          <select name="" class=form-control v-model="config.weekDifference" id="">
            <option value="-1">{{ $t('insights.ui.timespan.lastWeek') }}</option>
            <option value="0">{{ $t('insights.ui.timespan.currentWeek') }}</option>
          </select>
        </div>
        <div class="col-8">
        <label for="filter-value">Filter </label>
        <select name="filter-value" class="form-control" v-model="config.filterReason" id="filter-value">
<!--          <option :value="null">{{$t('ui.all')}}</option>-->
          <option
              :value="value" :key="value" v-for="value in getUniqueReasons">{{ value }}
          </option>
        </select>
        </div>
      </div>
    <div class="chart-container "    >
      <ComponentLoadSpinner :loading="loading"/>

      <bar-chart style="width: 100%; height: 100%"
                 v-if="config.filterReason"
                 :class="loading ? 'loading':''"
                 :chartData="getChartData"
                 :options="getOptions"/>

    </div>

  </div>


</template>

<script>
import BarChart from '@/components/insights/charts/barChart.js'
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";
import ComponentLoadSpinner from "@/components/general/ComponentLoadSpinner";


export default {
  components: {
    BarChart,
    ComponentLoadSpinner
  },
  mixins: [timeCalc, generalMethods, chartColors],
  props: ['editing'],
  data() {
    return {
      downTimes: [],
      loading:true,
      config: {
        weekDifference: 0,
        filterReason: null,
      }
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    getDowntimes() {
      return this.downTimes
    },
    getOptions() {
      const self = this
      return {
        ...this.generalChartOptions,
        scales: {
          xAxes: [
            {
              distribution: 'series',
              gridLines: {
                display: false
              },
              stacked: false,
              offset: true, // IF this i
              type: 'time',
              time: {
                unit: 'minute',
                round: 'minute',
                displayFormats: {
                  minute: 'D/MM HH:mm'
                }
              }
            },
          ],
          yAxes: [
            {
              id: 'time',
              ticks: {
                beginAtZero: true,
                autoSkip: true,
                maxTicksLimit: 10,
                stepSize: ((1000 * 60)) * 2 ,
                callback: function (label, index, labels) {
                  return self.getMinutesFromMilliseconds(label, false) + ' min'
                }
              }
            },
            // {
            //   id: 'count',
            //   position: 'right',
            //   ticks: {
            //     beginAtZero: false,
            //     stepSize: 2
            //   }
            // }
          ],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return moment(tooltip[0].label).format('MMM DD')
            },
            label: function (tooltipItem) {
              return self.formattedColonTime(tooltipItem.value)    //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: 'white',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 15
            },
            offset: -25,

            display: function (ctx) {
              // return false
              return true //ctx.datasetIndex >   0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
               return  self.getMinutesFromMilliseconds(value.y,false)
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    },
    getUniqueReasons() {
      const self = this
      return [...new Set(self.getDowntimes.map(dt => {
            try {
              if (dt.reason) {
                return dt.reason.join('|')
              }
            } catch (e) {
              console.log(e)
            }
          }
      ))].filter(Boolean).sort()
    },
    calculatedTarget() {
      const data = _.chain(this.getDownTimesGroupped).map((dt, id) => ({
        t: id,
        y: _.sumBy(dt, d => {
          return moment(d.downTimeEnded.toDate()).diff(d.downTimeIndicator.toDate())
        }),
      })).value()
      const count = _.chain(this.getDownTimesGroupped).map((dt, id) => ({
        t: id,
        y: 1
      })).value()
      return [data, count]

    },
    getDownTimesGroupped() {
      let filtered = _.filter(this.downTimes, dt => {
        if (dt.reason) {
          if (this.config.filterReason) {
            return this.config.filterReason === dt.reason.join('|')
          }else{
            return dt
          }
        }
      })
      return _.groupBy(filtered, (dt) => {
        return moment(dt.downTimeIndicator.toDate()).toDate()
      })
    },
    getChartData() {
      return {
        labels: [],
        datasets: [
          {
            yAxisID: 'time',
            label: this.$root.$t('insights.ui.duration'),
            backgroundColor: '#DD872E', //this.colors.downTimes.reasons,
            data: this.calculatedTarget[0],
          },
          // {
          //   yAxisID: 'count',
          //   label: 'Aantal',
          //   backgroundColor: 'grey',
          //   data: this.calculatedTarget[1]
          // },
        ]
      }
    }
  },
  methods: {
    async getDownTimesFromFirebase() {
      let userClaims = this.getClaims
      let time = moment().startOf('week').add(parseInt(this.config.weekDifference), 'week')
       try {
        this.loading = true
        let downTimes = (await this.$FBClient.firestore().collection('downTimes')
            .where('companyId', '==', userClaims.companyId)
            .where('downTimeIndicator', '>=', time.toDate())
            .where('downTimeIndicator','<=',time.endOf('week').toDate())
            .where('downTimeRunning', '==', false)
            .get()).docs.map(doc => {
          return doc.data()
        })
         this.loading = false
        this.downTimes = downTimes
      } catch (e) {
         this.loading = false
        console.log(e)
      }
      return false
    }

  },
  watch: {
    'config.weekDifference'() {
       this.getDownTimesFromFirebase()
    }
  },
  created() {

    this.getDownTimesFromFirebase()

  }
}
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";
</style>